<template>
  <div>
    <v-container class="mapcont" fluid><v-col>
      <v-row align="center" justify="center" >
        <MapaMeteocat
          class="ml-3 mr-3 mb-4"
          title="Predicció general de Catalunya"
          source="https://static-m.meteo.cat/ginys/mapaPrediccio?language=ca&color=880016"
        />

        <MapaMeteocat
          class="ml-3 mr-3 mb-4"
          title="Radar meteorològic"
          source="https://static-m.meteo.cat/ginys/mapaRadar?language=ca&color=880016"
        />

        <MapaMeteocat
          class="ml-3 mr-3 mb-4"
          title="Mapa d'avisos"
          source="https://static-m.meteo.cat/ginys/mapaAvisos?language=ca&color=880016"
        />

      </v-row>
      <v-row align="center" justify="center" >

        <MapaMeteocat
          class="ml-3 mr-3 mb-4"
          title="Predicció del perill d'incendi forestal"
          :image="true"
          source="https://www.gencat.cat/medinatural/incendis/mapes/mapweb.gif"
        />

        <MapaMeteocat
          class="ml-3 mr-3 mb-4"
          title="Mapa de pla alfa"
          :image="true"
          source="https://www.gencat.cat/medinatural/incendis/mapes/pla_alfa.gif"
        />
      </v-row>
    </v-col></v-container>
  </div>
</template>

<script>
 import MapaMeteocat from '@/components/MapaMeteocat';

 export default {
   name: 'Mapes',

   components: {
     MapaMeteocat,
   },

   data: () => ({
     //
   }),
 };
</script>
